import { useState } from 'react';
import { FormControl, Stack, FormLabel } from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';
import NameField from 'components/forms/new/formikFormFields/NameField';

const PlanOtherPortingFeeField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.otherPortingFee && touched.otherPortingFee}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Other Porting Fee
                </FormLabel>
                <Field
                    as={NameField}
                    id="otherPortingFee"
                    name="otherPortingFee"
                    data-walkthroughid={
                        walkthroughIds.plans.ufOtherPortingFeeInput
                    }
                    error={errors.otherPortingFee}
                    type="number"
                    step="any"
                />
                {isHovered && (
                    <FieldToolTip
                        label="Other porting fee (if any)."
                        ariaLabel="plan-other-porting-fee-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PlanOtherPortingFeeField;
